module.exports = __webpack_public_path__ + "2d77bbe8806965cedf23bfa5959409c9.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/assets/jacktop_baccarat.png
// module id = 1682
// module chunks = 2